/**
 * 事件管理
 * Bai.Zhiming
 * 2019-6-19
 */
angular.module("hEventManagementModule", [
    "hEditEventModule"
]).
controller("hEventManagementCtrl", ["$scope", "hiddenCodeManagementService", "modalDialog", "$q", "$state", "globleParamsSet", "trsHttpService", function($scope, hiddenCodeManagementService, modalDialog, $q, $state, globleParamsSet, trsHttpService) {
    initStatus();
    initData();
    /**
     * [stop description] 停用事件
     * @param  {[type]} item [description] 事件信息
     * @return {[type]}      [description]
     */
    $scope.stop = function(item) {
        modalDialog.alertType("被停用后，该事件将不会被统计，确定要停用吗？", "", "ask", true, () => {
            let params = {
                serviceid: "mlf_buridecode",
                methodname: "forbidden",
                id: item.id
            }
            hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
                requestData();
            });
        });
    };
    /**
     * 
     * [showSelectedArea description] 选择
     * @return {[type]} [description]
     */
    $scope.showSelectClassify = function(node) {
        let deffer = $q.defer();
        let params = {
            serviceid: "mlf_buridecode",
            methodname: "get",
            parentid: angular.isDefined(node.id) ? node.id : 0
        };
        hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(resp => {
            deffer.resolve(resp.data);
        });
        return deffer.promise;
    };
    /**
     * [selectedClassify description] 获取到分类的回调函数
     * @return {[type]} [description]
     */
    $scope.selectedClassify = function() {
        requestData();
    };
    /**
     * [buildRelationships description] 事件和模块建立关联关系
     * @param  {[type]} item [description] 事件信息
     * @return {[type]}      [description]
     */
    $scope.buildRelationships = function(item) {
        $state.go("manageconfig.sysmanage.hiddencodemanagement.eventmanagement.editevent", { eventinfo: JSON.stringify(angular.copy(item)) }, { reload: false });
    };
    /**
     * [fullTextSearch description] 关键词搜索
     * @return {[type]} [description]
     */
    $scope.fullTextSearch = function($event) {
        if ($event && $event.keyCode != 13) return;
        $scope.isSearch = $scope.status.keywords == "" ? false : true;
        requestData();
    }
    /**
     * [selectPageNum description] 选择每页大小
     * @return {[type]} [description]
     */
    $scope.selectPageNum = function() {
        requestData();
    };
    /**
     * [pageChanged description] 选页数
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        requestData();
    };
    /**
     * [jumpToPage description] 指定跳转到某一页
     * @return {[type]} [description]
     */
    $scope.jumpToPage = function() {
        $scope.page.CURRPAGE = $scope.status.copyCurrPage;
        requestData();
    };
    /**
     * [requestData description] 请求列表
     * @return {[type]} [description]
     */
    function requestData() {
        let params = handleParams();
        $scope.loadingPromise = hiddenCodeManagementService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
            $scope.data.items = resp.data.content;
            handlPage(resp.data);
        });
    }
    /**
     * [handleParams description] 处理参数
     * @return {[type]} [description]
     */
    function handleParams() {
        let params = angular.copy($scope.params);
        let classifyData = $scope.status.classifyData[0] ? $scope.status.classifyData[0] : [];
        params.startPage = $scope.page.CURRPAGE - 1;
        params.pageSize = $scope.page.PAGESIZE;
        params.module = classifyData[0] ? classifyData[0].parentclassify : "";
        params.classify = classifyData[1] ? classifyData[1].parentclassify : "";
        params.pages = classifyData[2] ? classifyData[2].parentclassify : "";
        params.operbutton = classifyData[3] ? classifyData[3].parentclassify : "";
        if ($scope.isSearch) {
            params.keyword = $scope.status.keywords;
        }
        return params;
    }
    /**
     * [handlPage description] 处理分页参数
     * @return {[type]} [description]
     */
    function handlPage(data) {
        $scope.page = {
            CURRPAGE: data.number + 1,
            ITEMCOUNT: data.totalElements,
            PAGESIZE: data.size,
            PAGECOUNT: data.totalPages
        }
        $scope.status.copyCurrPage = data.number + 1;

    }
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            keywords: '',
            classifyData: []
        };
        $scope.data = {};
        $scope.params = {
            module: '',
            classify: '',
            keyword: '',
            serviceid: 'mlf_buridecode',
            methodname: 'queryallstat'
        };
        /**
         * [page description:分页信息]
         */
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": globleParamsSet.getPageSize(),
            "ITEMCOUNT": 0,
            "PAGECOUNT": 1
        }
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        requestData();
    }
}]);